import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import icon from "../assets/icon.png";
import pivot0 from "../assets/pivot0.png";
import pivot from "../assets/pivot.png";
import pivot2 from "../assets/pivot2.png";
import { FaLinkedin } from "react-icons/fa";

const images = [pivot2, pivot, pivot0];

const Home = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="container">
            <div
                className="jumbotron mt-5"
                style={{
                    backgroundImage: `url(${images[currentImageIndex]})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center 65%",
                    backgroundRepeat: "no-repeat",
                    color: "white",
                    padding: "3rem",
                    borderRadius: "10px",
                    height: "500px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    position: "relative",
                    transition: "background-image 1s ease-in-out",
                    maxWidth: "100%",
                }}
            >
                <div
                    style={{
                        backgroundColor: "rgba(184, 221, 243, 0.5)",
                        backdropFilter: "blur(2px)",
                        padding: "2rem",
                        borderRadius: "15px",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                        maxWidth: "90%",
                    }}
                >
                    <img src={icon} alt="Icon" style={{ width: "100px", height: "auto", marginBottom: "1rem" }} />
                    <h1 className="display-3" style={{ color: "#000000", fontSize: "3rem", fontWeight: "550" }}>InteliRain™ Web Application</h1>
                    <p className="lead" style={{ color: "#000000", fontSize: "1.3rem", fontWeight: "450" }}>Advancing Irrigation Through Science</p>
                    <hr className="my-4" style={{ borderColor: "white", width: "80%", margin: "1rem auto" }} />
                    <Link to="/login" className="btn btn-primary btn-lg" role="button" style={{ fontSize: "1.2rem", padding: "0.8rem 2rem", backgroundColor: "#0064FF", color: "white", border: "2px solid #000000", borderRadius: "5px", transition: "background-color 0.3s ease" }} onMouseOver={(e) => (e.target.style.backgroundColor = "#0052cc")} onMouseOut={(e) => (e.target.style.backgroundColor = "#0064FF")}>
                        Get Started
                    </Link>
                </div>
            </div>

            {/* Footer */}
            <footer style={{ marginTop: "2rem", padding: "1rem", backgroundColor: "#f8f9fa", textAlign: "center", borderTop: "1px solid #ddd", display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <a href="https://ca.linkedin.com/company/intelirain-inc" target="_blank" rel="noopener noreferrer" style={{ color: "#007bff", fontSize: "2rem", display: "flex", alignItems: "center" }}>
                        <FaLinkedin />
                    </a>
                    <a href="https://intelirain-ag.com/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "#007bff", fontSize: "1rem", display: "flex", alignItems: "center" }}>About</a>
                    <a href="https://intelirain-ag.com/connect" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "#007bff", fontSize: "1rem", display: "flex", alignItems: "center" }}>Contact</a>
                    <a href="/dataconsent" style={{ textDecoration: "none" }}>
                        <button style={{ background: "none", border: "none", color: "#007bff", fontSize: "1rem", cursor: "pointer" }}>
                            Data Use & Consent
                        </button>
                    </a>

                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <img src={icon} alt="Company Logo" style={{ width: "30px", height: "30px" }} />
                    <span style={{ fontSize: "1rem", color: "#333" }}>© 2025 InteliRain Ag - All Rights Reserved.</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span style={{ fontSize: "1rem", color: "#333" }}>403-660-2936</span>
                </div>
            </footer>
            <style>
                {`
                @media (max-width: 768px) {
                    .jumbotron {
                        height: 350px !important;
                        padding: 2rem !important;
                    }
                    .jumbotron div {
                        padding: 1rem !important;
                        max-width: 95% !important;
                    }
                    h1 {
                        font-size: 2rem !important;
                    }
                    p {
                        font-size: 1rem !important;
                    }
                    .btn {
                        font-size: 1rem !important;
                        padding: 0.6rem 1.5rem !important;
                    }
                    footer {
                        flex-direction: column;
                        gap: 5px;
                    }
                }
                `}
            </style>
        </div>
    );
};

export default Home;
